import { Stack, Tooltip } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';

export type IconCellParams = ICellRendererParams & {
    showIcon: boolean;
    icon: React.ReactElement;
    tooltip: string;
    end?: boolean;
};

export function IconCell({ valueFormatted, value, showIcon, tooltip, icon, end }: IconCellParams) {
    if (showIcon) {
        return (
            <Stack
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: 2,
                    flexDirection: end ? 'row-reverse' : 'row',
                }}
            >
                <Tooltip title={tooltip}>{icon}</Tooltip>
                {valueFormatted ?? value}
            </Stack>
        );
    }

    return <>{valueFormatted ?? value}</>;
}
